import React, { Component } from "react";
import { AppConfig } from "../../helpers";
import TeamName from "../common/betEvents/TeamName";
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';


export class Teams extends Component {
  state = {};
  checkImage = (teamId) => {
    this.setState({
      [teamId]: true,
    });
  };
  render() {
    const { teamName, teamId, teamColor } = this.props;
    return (
      <>
        {!this.state[teamId] && (
          <div style={{ paddingRight: "5px" }}>
            <LazyLoadImage
              src={`${AppConfig.teamsIconPath}${teamId}_s.webp`}
              alt="leagues-icon"
              // style={{marginLeft:"2px"}}

              onError={() => this.checkImage(teamId)}
            />
          </div>
        )}
        {this.state[teamId] &&
        teamName.includes(" ") &&
        teamName.split(" ").length >= 2 ? (
          <div
            style={
              teamColor && teamColor != "ffffff"
                ? {
                    backgroundColor: `#${teamColor}`,
                  }
                : { backgroundColor: "#AEB4BF" }
            }
            className="events-alternative-image"
          >
            {" "}
            <span>{teamName.split(" ")[0][0]}</span>
            <span>{teamName.split(" ")[1][0]}</span>
          </div>
        ) : this.state[teamId] ? (
          <div
            style={
              teamColor && teamColor != "ffffff"
                ? {
                    backgroundColor: `#${teamColor}`,
                  }
                : { backgroundColor: "#AEB4BF" }
            }
            className="events-alternative-image"
          >
            {" "}
            <span>{teamName.split(" ")[0][0]}</span>
          </div>
        ) : (
          ""
        )}
        <TeamName name={teamName} />
      </>
    );
  }
}

export default trackWindowScroll(Teams);
